
import { Component, Injector, OnInit } from '@angular/core';
import { BookmarkService } from 'tnx-admin-service/bookmark/services';
import { ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'bookmark-form',
    templateUrl: './bookmark-form.component.html',
    styleUrls: ['./bookmark-form.component.scss'],
    providers: [ComponentContextService],
})
export class BookmarkFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _bookmarkService: BookmarkService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._bookmarkService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'name',
                label: ''
            }),
            new TextControlSchema({
                field: 'templateId',
                label: ''
            }),
            new TextControlSchema({
                field: 'dataType',
                label: ''
            }),
            new TextControlSchema({
                field: 'dataFormat',
                label: ''
            }),
            new TextControlSchema({
                field: 'code',
                label: ''
            }),
            new TextControlSchema({
                field: 'parentName',
                label: ''
            })
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

